// extracted by mini-css-extract-plugin
module.exports = {"container":"divider_container__EIz3g","direction--vertical":"divider_direction--vertical__Bje5L","direction--horizontal":"divider_direction--horizontal__DJt9U"};